// you can add any STATIC data you want here
import pkg from "../../package.json"

export default {
  pkg,
  // you can add any DYNAMIC data you need here
  // ...
}



/** WEBPACK FOOTER **
 ** ./web_modules/app/metadata.js
 **/